var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v(_vm._s(_vm.getType( this.$route.params.typeAbbr).report_name))])]),_c('v-flex',{attrs:{"xs12":""}},[(_vm.isManager)?_c('div',_vm._l((_vm.btns),function(ref,index){
var caption = ref[0];
var path = ref[1];
return _c('v-menu',{key:index,attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-btn',{attrs:{"to":path}},[_vm._v(" "+_vm._s(caption)+" ")])]}}],null,true)})}),1):_vm._e()]),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }